import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { PostAdminContext } from "./Posts"
import { useContext } from "react"
import { statuses } from "../util/helpers"

const PostStatusFilter = ({ maxWidth }) => {
	const postAdminContext = useContext(PostAdminContext)
	const filter = postAdminContext.filter
	const handleStatusFilter = postAdminContext.handleStatusFilter

	return (
		<Select
			sx={{ mt: 1, maxWidth: maxWidth ?? "auto", mb: 1 }}
			size="small"
			value={filter}
			label="סטטוס"
			onChange={handleStatusFilter}
		>
			<MenuItem key={"NONE"} value={""}>
				--ללא--
			</MenuItem>
			{Object.keys(statuses).map((key) => (
				<MenuItem key={key} value={key}>
					{statuses[key]}
				</MenuItem>
			))}
		</Select>
	)
}

export default PostStatusFilter
